export default __webpack_public_path__ + "static/media/Screenshot_5.3eabc329.png";